import { Observable } from 'rxjs';
import { GGProductRetailersListWsDTO } from './occ.partner-link-list.adapter';

export abstract class PartnerLinkListAdapter {
  abstract fetchPartnerLinkList(actionType: string, productCode: string): Observable<GGProductRetailersListWsDTO>;
}
